<template>
<div class="Footer">
  <div class="Wrapper">
    遠時數位科技股份有限公司為遠傳電信集團關係企業 / 版權所有 copyright © 2017 YSDT. All Rights Reserved.
    <div class="GoContect">
      <a href="https://shopping.friday.tw/interact/CustomerService.do?method=init" target="_blank" title="聯絡我們">聯絡我們</a>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "footerComponent"
};
</script>

<style lang="scss" scoped>
</style>
